import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import {
    MAT_LEGACY_DIALOG_DATA,
    MatLegacyDialogModule,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { take } from 'rxjs/operators';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import {
SelectSearchOption
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { arlTableDataArlForm } from '../arl-calculation/arl-form-data.service';
import { Observable } from 'rxjs';
import {
    IDetailListTemplateData
} from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { PriceComparison } from '@dave/types';
import { PriceComparisonComponentDialogData } from '../arl-calculation/price-comparison/price-comparison.component';
import { HintIconComponent } from '../../../hint-icon/hint-icon.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { NewBookingOptionComponentReturnType } from '../new-booking-option/new-booking-option.component';
import {
    MatLegacyPaginatorIntl as MatPaginatorIntl,
    MatLegacyPaginatorModule,
} from '@angular/material/legacy-paginator';
import {
    SelectSearchPagedOptionsComponent
} from '../../../dave-utils-module/select-search/components/select-search-paged-options/select-search-paged-options.component';
import { CustomerDataService, CustomerSearchState } from '../../../dave-data-module/services/customer-data.service';
import { GermanPaginatorIntl } from '../../../services/german-paginator-intl.service';

interface SelectSupplierDialogDataR {
    Confirmed?: boolean;
    SupplierId?: number;
    SelectedFillEmptyValuesWithMtS?: boolean;
}

export type SelectSupplierDialogData = {
    showCheckbox?: boolean;
    header?: string;
    showDeleteButton?: boolean;
    tooltip?: string;
    supplierId?: number;
    disableDropDown?: boolean;
    infoText?: string;
}
export type SelectSupplierDialogReturnData = SelectSupplierDialogDataR

@Component({
    selector: 'app-select-supplier-dialog',
    standalone: true,
    imports: [CommonModule, AppButtonModule, MatLegacyDialogModule, SelectSearchModule, MatLegacyFormFieldModule, MatLegacyCheckboxModule, FormsModule, ReactiveFormsModule, HintIconComponent, FontAwesomeModule, MatLegacyTooltipModule, MatLegacyPaginatorModule, SelectSearchPagedOptionsComponent],
    providers: [{ provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
    templateUrl: './select-supplier-dialog.component.html',
    styleUrls: ['./select-supplier-dialog.component.scss'],
})

export class SelectSupplierDialogComponent {
    protected supplierLabel$: Observable<string> = this.cls.getSingle$('Supplier');
    protected header:string | null;
    protected showCheckbox:boolean;
    protected tooltip:string | null;
    protected showDeleteButton:boolean;
    protected disableDropDown:boolean;
    protected infoText:string | null;


    protected NewEventForm = new FormGroup({
        Customer: new FormControl<SelectSearchOption<{ Id: number }> | null>(null),
    });

    protected customerSearch: CustomerSearchState = this.customerDataService.createSearchState({ onlySuppliers: true });
    protected customerLable: string = '';
    constructor(
        protected cls: CustomLabelService,
        @Inject(MAT_LEGACY_DIALOG_DATA) dialogData: SelectSupplierDialogData,
        private dialogRef: MatDialogRef<SelectSupplierDialogComponent, SelectSupplierDialogDataR>,
        private customerDataService: CustomerDataService,
    ) {
        if (dialogData?.header){
            this.customerLable = "Bieter"
        }else{
            this.supplierLabel$.pipe(take(1)).subscribe((label) => this.customerLable = label);
        }
        this.infoText = dialogData?.infoText;
        this.tooltip = dialogData?.tooltip;
        this.showDeleteButton = dialogData?.showDeleteButton ?? false;
        this.disableDropDown = dialogData?.disableDropDown ?? false;
        this.header = dialogData?.header;
        this.showCheckbox = dialogData?.showCheckbox ?? true;
        if (this.disableDropDown) {
            this.NewEventForm.controls.Customer.disable();
        }
        if (dialogData?.supplierId != null) {
            // Id sofort setzen, damit sie beim Bestätigen auch ohne geladenen Kunden zurückgegeben wird
            this.NewEventForm.controls.Customer.setValue({ Id: dialogData.supplierId, optionLabel: '' });
            this.customerDataService
                .GetSingleCustomer$(dialogData.supplierId)
                .pipe(take(1))
                .subscribe((customer) => {
                    this.NewEventForm.controls.Customer.setValue({ Id: customer.Id, optionLabel: customer.DisplayName });
                });
        }
    }

    protected get selectedSupplierId(): number | null {
        return this.NewEventForm.getRawValue().Customer?.Id ?? null;
    }
    protected selectedFillEmptyValuesWithMtS: boolean = true;

    removeSupplier(){
        this.dialogRef.close({ Confirmed: true, SupplierId: null, SelectedFillEmptyValuesWithMtS: this.selectedFillEmptyValuesWithMtS });
    }
    protected customerCompareOptions = (a, b) => a?.Id === b?.Id;
    protected customerpageChange = (event) => this.customerSearch.customerPageChange(event);
    protected customerserverSearch = (search) => this.customerSearch.SearchCustomers(search, 'unbenannter ' + this.customerLable);
    public compareById = (a: {Id} | null, b: {Id} | null) => (a?.Id ?? null) === (b?.Id ?? null);
}
